import { PaymentMethod, PaymentMethodStatus } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { getCardBrand } from '@frontend/payments-card-brand';
import { PaymentMethodCardUI } from '@frontend/payments-card-on-file';
import { classNames, titleCase } from '@frontend/string';

export type PaymentMethodCardProps = {
  isSelected: boolean;
  paymentMethod: PaymentMethod;
  className?: string;
  onSelectPaymentMethod: (pm: PaymentMethod) => void;
  onClickDelete?: (pm: PaymentMethod) => void;
};
export const PaymentMethodCard = ({
  isSelected,
  paymentMethod,
  className,
  onSelectPaymentMethod,
  onClickDelete,
}: PaymentMethodCardProps) => {
  const { t } = useTranslation('payments');

  return (
    <PaymentMethodCardUI
      className={classNames('payment-methods__payment-method--card', className)}
      brand={getCardBrand(paymentMethod.card?.brand)}
      title={titleCase(paymentMethod.card?.brand)}
      last4={paymentMethod.card?.last4}
      expMonth={paymentMethod.card?.expMonth}
      expYear={paymentMethod.card?.expYear}
      methodId={paymentMethod.id}
      selected={isSelected}
      onClick={() => onSelectPaymentMethod(paymentMethod)}
      disabled={paymentMethod.status === PaymentMethodStatus.PAYMENT_METHOD_STATUS_EXPIRED}
      status={paymentMethod.status}
      actions={
        !!onClickDelete
          ? [
              {
                icon: 'trash',
                label: t('Delete'),
                onClick: () => onClickDelete(paymentMethod),
              },
            ]
          : []
      }
    />
  );
};
